import { render, staticRenderFns } from "./PropagandistSelect.vue?vue&type=template&id=4250b508&"
import script from "./PropagandistSelect.vue?vue&type=script&lang=js&"
export * from "./PropagandistSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports